/* eslint-disable react/prop-types */
import React from 'react';
import Amount from 'components/Amount';
import InfoHoverBlock from 'components/success/InfoHoverBlock';
import nextEnergy from 'images/icons/nextEnergy.svg';

class RenoPrimeBlock extends React.Component {
  render() {
    const infoReno = this.props.APIresult['Information Rénovation globale'];

    if (!this.props.renoTagOffer && !this.props.APIresult['Prime MAR'])
      return null;

    const InfoComponent = ({ infoReno }) => {
      return (
        <div className="renoItem">
          {infoReno.map((info, index) => (
            <div
              key={index}
              className={`${info.letter.join(', ') === this.props.renoTagOffer?.letter.join(', ') ? 'selected' : 'unselected'}`}
            >
              <label className="d-flex jcsb">
                <div className="d-flex aic ">
                  <input
                    type="radio"
                    value={info.letter.join(', ')}
                    name="reno"
                    checked={
                      info.letter.join(', ') ===
                      this.props.renoTagOffer?.letter.join(', ')
                    }
                    onChange={this.props.handleRenoTagOffer}
                  />
                  <img
                    src={`https://www.hellio.com/hubfs/simulateur/icons3/tags/${this.props.energyTag}.svg`}
                    className="ml-5"
                  />
                  <img src={nextEnergy} className="mh-5" />
                  {info.letter.map((item) => (
                    <img
                      key={item}
                      src={`https://www.hellio.com/hubfs/simulateur/icons3/tags/${item}.svg`}
                      className="mr-5"
                    />
                  ))}
                </div>
                <h2 className="whitespace-nowrap">
                  - <Amount value={info.prime} />
                </h2>
              </label>
            </div>
          ))}
        </div>
      );
    };

    return (
      <div className="flex flex-col gap-[10px]">
        <InfoHoverBlock
          data={this.props.APIresult}
          success={this.props.success}
          item="Prime2"
          showTooltip
        />
        <InfoComponent infoReno={infoReno} />
        <hr className="hr-reno" />
      </div>
    );
  }
}

export default RenoPrimeBlock;
